import React from "react";

class Settings extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="animated">
                    Settings
                </div>
            </div>
        );
    }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/views/pages/settings/index.js